<template>
  <div>
    <v-card>
      <v-snackbar
        :timeout="timeout"
        :top="y === 'top'"
        :bottom="y === 'bottom'"
        :color="color"
        :right="x === 'right'"
        :left="x === 'left'"
        :multi-line="mode === 'multi-line'"
        :vertical="mode === 'vertical'"
        v-model="val"
      >
        {{ mesaj }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{
          $t("Close")
        }}</v-btn>
      </v-snackbar>
    </v-card>

    <v-dialog v-model="dialog" width="500" persistent>
      <v-card>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark :color="titleColor">
            <v-toolbar-title>{{ title }}</v-toolbar-title>
          </v-toolbar>
        </v-flex>

        <v-card-text>
          <blockquote>{{ message }}</blockquote>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialog = false"> Kapat </v-btn>
          <v-btn color="primary" v-if="mailVisible" flat @click="sendMail()">
            Arkman'a Mail At
          </v-btn>
          <v-btn color="primary" v-if="ticketVisible" flat @click="refleshPage()">
            Getir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
import auth from "../../../api/auth";
import axios from "axios";

export default {
  // props: ["value","mesaj"],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    mesaj: {
      type: String,
    },
    color: {
      type: String,
      default: null,
    },
  },
  components: {},
  computed: {
    val: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },
  beforeMount: beforeMount,
  filters: {},

  methods: {
    refleshPage(){
      location.reload();
    },
    open(value) {
      //data.type 1 = error , 2 = warning , 3 = uyari + "Getir" butonu
      this.data = value;
      this.dialog = true;
      this.message = value.message;

      // Butonlar HER acilista bastan kuruluyor. Onceden yalnizca KAPATILMALARI
      // yaziliydi: type 2 ve 3 mailVisible'i false yapiyor, type 1 onu geri
      // ACMIYORDU. Bileseni bir kez uyari icin kullanan sayfada, sonraki gercek
      // hatada "Arkman'a Mail At" butonu kayboluyordu -- kullanicinin hatayi
      // bildirdigi tek yol o. type 3 artik siradan bir kayit catismasinda da
      // aciliyor (bkz. BILET_DEGISMIS), yani bu sira cok daha sik olusuyor.
      this.mailVisible = false;
      this.ticketVisible = false;

      switch (value.type) {
        case 1:
          this.title = "Hata";
          this.titleColor = "error";
          this.type = value.type;
          this.mailVisible = true;
          break;
        case 2:
          this.title = "Uyarı";
          this.titleColor = "warning";
          this.type = value.type;
          break;
        case 3:
          this.title = "Uyarı";
          this.titleColor = "warning";
          this.type = value.type;
          this.ticketVisible = true;
        break;

      }
    },
    sendMail() {
      let formData = new FormData();

      formData.append("Konu", "Arkman Next Dialog Hata E-mail");
      formData.append("to", "logcontrol@arkman.com.tr");
      formData.append("mailType", "0");
      let msg1 = JSON.stringify(this.data);
      var jsonPretty = JSON.stringify(JSON.parse(msg1), null, 2);

      formData.append("formattedMessage", jsonPretty);

      axios.defaults.baseURL = auth.API_URL;

      let credentials = JSON.parse(window.localStorage.getItem("credentials"));

      axios.defaults.headers.post["Content-Type"] = "multipart/form-data";
      axios
        .post(auth.API_URL + "api/Helpers/SendEmailWithError", formData, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
            CariSirketNo: credentials.SirketKodu.toString(),
            CoperSirketNo: credentials.CoperSirketNo.toString(),
          },
        })
        .then((response) => {
          if (response.data == true) {
            this.text1 = "Mail Gönderildi.";
            this.snackbar = true;
          } else {
            this.text1 = this.$t("Mail-system-not-right-now-send-manual-mail");
            this.snackbar = true;
          }
        })
        .catch((error) => {
          this.text1 = this.$t("Mail-system-not-right-now-send-manual-mail");
          this.snackbar = true;
        });
      this.dialog = false;
    },
    htmlEncode: function (str) {
      str = str.replace(/&/g, ".....");
      str = str.replace(/"/g, "_____");
      str = str.replace(/</g, "-----");
      str = str.replace(/>/g, "+++++");
      return str;
    },
  },
  data() {
    return {
      mailVisible: true,
      ticketVisible:true,
      data: {},
      title: null,
      dialog: false,
      message: null,
      titleColor: null,
      type: 0,
      loading: false,
      snackbar: false,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
    };
  },

  watch: {},
};

function beforeMount() {}
</script>